import React from 'react';

export const NotificationContainer = props => (
  <div className="notification-container">{props.children}</div>
);

export const toast = (message, options) => {
  const { timeout } = options;
  const container = document.querySelector('.notification-container');
  const notifier = document.createElement('div');
  notifier.classList.add('notify');
  notifier.classList.add(`toast-${options.status}`);
  notifier.classList.add('show');

  const textNode = document.createElement('p');
  textNode.textContent = message;
  notifier.appendChild(textNode);

  container.appendChild(notifier);

  setTimeout(() => {
    notifier.classList.remove('show');
  }, timeout || 5000);

  setTimeout(() => {
    container.removeChild(notifier);
  }, timeout + 500 || 5500);
};
